import { Injectable } from '@angular/core';
import { findIndex, Observable, of, Subject } from 'rxjs';
import { JsonApiListWrap, JsonApiWrap } from '../../shared/models/JsonApiWrap';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { FeatureFlagService } from '../../shared/services/feature-flag-service';
import { IntegrationService } from '../../shared/services/integration.service';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { InternalTransferAcknowledgeListRequest, InternalTransferAcknowledgeRequest } from '../models/internal-transfer/InternalTransferAcknowledgeRequest';
import { InternalTransferAcknowledgeResponse, InternalTransferListAcknowledgeResponse } from '../models/internal-transfer/InternalTransferAcknowledgeResponse';
import { InternalTransferInputRequest } from '../models/internal-transfer/InternalTransferInputRequest';
import { InternalTransferInputResponse } from '../models/internal-transfer/InternalTransferInputResponse';
import { InternalTransferPositionsResponse } from '../models/internal-transfer/InternalTransferPositionsResponse';
import { InternalTransferListVerifyRequest, InternalTransferVerifyRequest } from '../models/internal-transfer/InternalTransferVerifyRequest';
import { InternalTransferListVerifyResponse, InternalTransferVerifyResponse } from '../models/internal-transfer/InternalTransferVerifyResponse';

@Injectable({
  providedIn: 'root'
})
export class InternalTransferService {
  mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';
  destroy$: Subject<boolean> = new Subject<boolean>();
  acknowledgementConsentEnabled: boolean;

  constructor(
    private headersService: HeadersService,
    private baseService: BaseRestService,
    private featureFlagService: FeatureFlagService,
    private integrationService: IntegrationService,
  ) {
  }

  callInternalTransferInput(requestData: InternalTransferInputRequest): Observable<InternalTransferInputResponse> {
    let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/JournalInput';
    let requestBody: JsonApiWrap<InternalTransferInputRequest> = {
      data: {
        attributes: requestData,
        type: 'journal-input-request',
        id: ''
      }
    }
    let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');

    return this.baseService.post<InternalTransferInputRequest, InternalTransferInputResponse>(serviceUrl, headers, requestBody, true);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  callInternalTransferPositions(subAccount: string, toAccount: string): Observable<InternalTransferPositionsResponse> {
    let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/PositionsLot';
    let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Schwab-Client-Ids'] = 'fromAccount=' + subAccount + ',toAccount=' + toAccount;

    return this.baseService.get<InternalTransferPositionsResponse>(serviceUrl, headers, true);
  }

  callInternalTransferListVerify(requestData: InternalTransferListVerifyRequest[]): Observable<InternalTransferListVerifyResponse> {
    let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/JournalListVerify';
    let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    let requestBody = {
      data: requestData
    };
    return this.baseService.post<JsonApiListWrap<InternalTransferVerifyRequest>, InternalTransferListVerifyResponse>(serviceUrl, headers, requestBody, false);
  }

  callInternalTransferVerify(requestData: InternalTransferVerifyRequest): Observable<InternalTransferVerifyResponse> {
    let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/JournalVerify';
    let requestBody: JsonApiWrap<InternalTransferVerifyRequest> = {
      data: {
        attributes: requestData,
        type: 'journal-verify-request',
        id: ''
      }
    }
    let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    return this.baseService.post<InternalTransferVerifyRequest, InternalTransferVerifyResponse>(serviceUrl, headers, requestBody, true);
  }

  callInternalTransferAcknowledge(requestData: InternalTransferAcknowledgeRequest): Observable<InternalTransferAcknowledgeResponse> {
    let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/JournalAcknowledge';
    let requestBody: JsonApiWrap<InternalTransferAcknowledgeRequest> = {
      data: {
        attributes: requestData,
        type: 'journal-acknowledge-request',
        id: ''
      }
    }
    let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
        headers["Acknowledgement-Consent"] = "true";

    return this.baseService.post<InternalTransferAcknowledgeRequest, InternalTransferAcknowledgeResponse>(serviceUrl, headers, requestBody, true);
  }
  
  callInternalTransferListAcknowledge(
    requestData: InternalTransferAcknowledgeListRequest[]
  ): Observable<InternalTransferListAcknowledgeResponse> {
    let serviceUrl =
      this.integrationService.JfkEnv.BaseUrl +
      this.mmExperienceApiPath +
      '/v1/JournalListAcknowledge';
    let requestBody = {
      data: requestData,
    };

    let headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Acknowledgement-Consent'] = 'true';
    return this.baseService.post<JsonApiListWrap<InternalTransferAcknowledgeRequest>, InternalTransferListAcknowledgeResponse
    >(serviceUrl, headers, requestBody, false);
  }
}
